<span class="text-3xl">{{ 'salesIntelligence.title' | translate }}</span>

<p>{{ 'salesIntelligence.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'salesIntelligence.button.action' | translate }}
</button>
